import * as React from "react";

import connectToList from "../../store/list";

import GenButton from "../Gen/Button";
import GenControlsBar from "../Gen/ControlsBar";
import GenListDisplay from "../Gen/ListDisplay";
import GenMore from "../Gen/More";
import GenSearchBox from "../Gen/SearchBox";
import GenSelectBar from "../Gen/SelectBar";
import GenSortButtons from "../Gen/SortButtons";

import DocumentListControls from "../Document/ListControls";

import { documentDisplayTitle } from "../../src/document_display_title";
interface GroupDocumentCreateBatchSelectListProps {
  groupDocuments: ConnectedList<GroupDocumentSnakeModel>;
  groups: ConnectedList<GroupSnakeModel>;
}

function GroupDocumentCreateBatchSelectList(props: GroupDocumentCreateBatchSelectListProps) {
  const {
    groupDocuments,
    groups,
  } = props;

  React.useEffect(() => {
    groupDocuments.setListItemsPerPage(2000);
    groupDocuments.mountList("/group_documents/new_batch");
    groups.setListItemsPerPage(2000);
    groups.mountList("/groups");
  }, []);

  const [isSubmitLoading, setIsSubmitLoading] = React.useState(false);

  const handleSubmitButton = React.useCallback(() => {
    if (groupDocuments.selected.length === 0) {
      alert("Nothing Selected! You must select at least one item to lend.");
      return(null);
    }

    if (groups.selected.length === 0) {
      alert("Nothing Selected! You must select at least one group to lend to.");
      return(null);
    }

    const data = {
      groupDocumentIds: groupDocuments.selected.map((groupDocument) => groupDocument.id),
      groupIds: groups.selected.map((group) => group.id),
    };

    setIsSubmitLoading(true);

    fetch("/group_documents/create_batch", {
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (!response.ok) { throw new Error(`${response.status} response` ); }

        return response.json();
      })
      .then(Turbo.visit("/documents"))
      .catch(() => {
        setIsSubmitLoading(false);
      });
  }, [groupDocuments.selected, groups.selected]);

  return(
    <div>
      <div className="submit-panel">
        <h1>Lend Cases To Group</h1>
        <GenButton
          name="Lend"
          highlighted
          loading={isSubmitLoading}
          onClick={handleSubmitButton}
        />
      </div>
      <div className="two-columns">
        <div className="column">
          <div className="panel">
            <h1>Groups</h1>
          </div>
          <GenSelectBar
            {...groups}
            itemType="group(s)"
          />
          <GenControlsBar>
            <GenSearchBox
              {...groups}
            />
            <GenSortButtons
              {...groups}
              sortOptions={[
                {
                  "title": "Name",
                  "value": "groups.name",
                },
                {
                  "title": "ID",
                  "value": "groups.id",
                },
              ]}
            />
          </GenControlsBar>
          <GenListDisplay
            {...groups}
            renderItem={(group) => <span>{group.id} | {group.name}</span>}
          />
          <GenMore
            {...groups}
            shouldInfiniteScroll
          />
        </div>
        <div className="column">
          <div className="panel">
            <h1>Cases</h1>
          </div>
          <GenSelectBar
            {...groupDocuments}
            itemType="case(s)"
          />
          <DocumentListControls
            documents={groupDocuments}
          />
          <GenListDisplay
            {...groupDocuments}
            renderItem={(groupDocument) => <span>{documentDisplayTitle(groupDocument.document)}</span>}
          />
          <GenMore
            {...groupDocuments}
            shouldInfiniteScroll
          />
        </div>
      </div>
    </div>
  );
}

export default connectToList(GroupDocumentCreateBatchSelectList, ["groups", "groupDocuments"]);
